import React, { useEffect, useRef } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('token');

  // Durée max d’inactivité : 1 heure
  const INACTIVITY_LIMIT = 60 * 60 * 1000;
  const inactivityTimer = useRef(null);

  const resetTimer = () => {
    // on efface le timer précédent
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }
    // on reprogramme le logout automatique dans X ms
    inactivityTimer.current = setTimeout(() => {
      sessionStorage.removeItem('token');
      navigate('/');
    }, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    // si pas de token => pas logué => on ne fait rien
    if (!token) return;

    // on initialise le timer
    resetTimer();

    // On écoute tous les events pertinents
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    const handleUserActivity = () => {
      resetTimer();
    };

    events.forEach((evt) => {
      window.addEventListener(evt, handleUserActivity);
    });

    // cleanup quand on quitte la page
    return () => {
      events.forEach((evt) => {
        window.removeEventListener(evt, handleUserActivity);
      });
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }
    };
  }, [token, navigate]);

  if (!token) {
    return <Navigate to="/" />;
  }

  return children;
}